import { motion } from "framer-motion";
import { waLink } from "@/lib/site";
import { WhatsAppIcon } from "./WhatsAppIcon";

export const FloatingWhatsApp = () => (
  <motion.a data-testid="floating-whatsapp-btn" href={waLink()} target="_blank" rel="noopener noreferrer" aria-label="WhatsApp enquiry"
    initial={{ scale: 0, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} transition={{ delay: 1.4, type: "spring", stiffness: 220, damping: 16 }}
    whileHover={{ scale: 1.06 }} whileTap={{ scale: 0.95 }}
    className="fixed z-40 bottom-5 right-5 sm:bottom-8 sm:right-8 inline-flex items-center gap-2 h-14 pl-4 pr-5 rounded-full bg-[#25D366] text-[#0b2e17] font-bold shadow-[0_18px_40px_-10px_rgba(37,211,102,0.65)]">
    <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-20" />
    <WhatsAppIcon className="relative h-6 w-6" />
    <span className="relative text-sm">Enquire</span>
  </motion.a>
);
